import { ActionReducer } from '@ngrx/store';
import { AuthActionTypes } from '../actions/auth.actions';

/**
 * Meta-reducer qui reset tout le state au logout
 * 
 * Pattern NgRx officiel pour reset le state :
 * https://ngrx.io/guide/store/metareducers
 * 
 * Utilisation : Au logout, retourne undefined pour que chaque reducer
 * réinitialise son state à initialState
 */
export function clearState(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    // Si action = LOGOUT, reset le state à undefined
    // Chaque reducer recevra undefined et retournera son initialState
    if (action.type === AuthActionTypes.Logout) {
      console.log('[Meta-Reducer] Logout détecté, reset complet du store');
      state = undefined;
    }

    return reducer(state, action);
  };
}
